export default {
	about: 'About us',
	mission: 'Mission',
	vision: 'Our Vision',
	policy: 'Policy',
	qualityPolicy: 'Quality policy'
}